// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8DCQS","rootMobile":"styles_rootMobile__vUuvJ"};